<template>
    <div>
        <form v-on:submit.prevent="onSubmit">
            <div>
                <input class="button input input--s" type="text" v-model="voucherCode">
                <button type="submit" class="button button--small button--primary">
                    {{processing ? 'Ověřuji...' : 'Uplatnit'}}
                </button>
            </div>
            <ssv-order-error-state message="Zadaný slevový kód se nepodařilo najít." v-if="error"/>
        </form>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import {verifyVoucher} from '../api/voucher';
    import SsvOrderErrorState from '../error/ErrorState';

    export default {
        name: 'SsvOrderVoucherForm',
        components: {
            SsvOrderErrorState
        },
        data: () => {
            return {
                processing: false,
                error: false,
                voucherCode: ''
            }
        },
        methods: {
            ...mapActions('ssvOrder', ['verifyVoucher']),
            onSubmit() {
                this.processing = true;
                this.error = false;
                this.verifyVoucher(this.voucherCode)
                    .catch(() => this.error = true)
                    .finally(() => this.processing = false);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/voucher/VoucherForm.vue